/* eslint-disable no-unused-vars,camelcase,no-restricted-syntax,no-restricted-globals,consistent-return */

/* global _OL_ORIGIN _WEB */
import urlParser from 'url';
import $ from 'jquery';
import Immutable from 'immutable';
import Cookies from 'universal-cookie';
import { SubmissionError } from 'redux-form';
import { StackActions } from '../../native/bridge/ReactNavigation';
import { LoginManager } from '../../native/bridge/FacebookSDK';
import CookieManager from '../../native/bridge/CookieManager';
import Resource, { ResourceApi } from '../../resource/Resource';
import { Alert } from '../../native/bridge/AlertManager';
import { selectFiltersForFeed } from '../Courses/CourseFeed/selectors';
import { USER_RESOURCE, PAGE as PAGE_RESOURCE } from '../resourceNames';
import { metrics } from '../../web/metrics/metrics';
import { parseQueryString } from '../../web/utilities/utilities';
import { UserServerActionCreators } from '../../web/data/actions/UserServerActionCreators';
import { NO_EDUCATOR_SUBSCRIPTION_INTEGRATIONS } from '../../web/client-data/site-data';
import {
  UPDATE_ENROLLED_CLASS_DATA,
  START_FETCH_ENROLLED_CLASS_DATA,
  SET_ENROLMENTS_HISTORY,
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  FACEBOOK_LOGIN_START,
  FACEBOOK_LOGIN_SUCCESS,
  FACEBOOK_LOGIN_FAILURE,
  RESET_PASSWORD_START,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  LOGOUT_START,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  SIGNUP_FAILURE,
  SIGNUP_START,
  SET_LEGACY_TOKEN,
  SET_SUBDOMAIN_COOKIE,
  SET_IN_PROGRESS_FALSE,
  AUTH_SET_CURRENT_COHORT,
  AUTH_SET_CURRENT_COURSE,
  AUTH_SET_CURRENT_PORTAL_NAME,
  CANCEL_LOGIN,
  CLEAR_RETRIES_QUEUE,
  FORGOT_PASSWORD,
  LOGIN_REQUIRED,
  SET_CURRENT_USER,
  SET_CURRENT_USER_ACCESS,
  SSO_USER_CONTEXT,
  CURRENT_SSO_USER_DETAILS,
  SIGNUP_USER_REQUIRED,
  SIGNUP_SUCCESS,
  SET_LOGIN_DATE,
  SET_LOGIN_MODE,
  CANCEL_FORGOT_PASSWORD,
} from './actions';
import {
  APP_TABS,
  AUTH_STACK,
  ACTIVITY_FEED_SCREEN,
  LOGIN_SCREEN,
  MY_COURSES_SCREEN,
} from '../routeActions';
import { APP_TAB_SET_PARAMS } from '../Nav/AppTabs/constants';
import { stackAction, navigate } from '../../native/bridge/NavigationService';
import { fetchUnreadBadge } from '../Notifications/dispatchers';
import { loadCurrentUserSubscriptionPlanData } from '../UserSubscriptionPlans/dispatchers';
import {
  clearFCMTokenFromServer,
  registerPushNotificationToken,
} from '../PushNotification/dispatchers';
import { initializeFilterForFeed } from '../Filters/dispatchers';
import {
  selectHasRequestedEnrolledClassData,
  currentUserIdSelector,
} from './selectors';
import { makeSelectWhiteLabelInstitution } from '../Institutions/selectors';
import { selectCurrentCoursePath } from '../Courses/selectors';
import { selectCurrentUserEducatorSubscription } from '../UserSubscriptionPlans/selectors';
import {
  getToken,
  setToken,
  removeToken,
} from '../../native/helper/TokenHelper';
import { showNotification } from '../../native/helper/InAppNotificationHelper';
import {
  setUserContext,
  setExtraContext,
  clearContext,
  setEnvironment,
} from '../../native/bridge/CrashReportingHelper';
import {
  setUser,
  clearIdentity,
} from '../../native/bridge/SegmentAnalyticHelper';
import { LoginMode } from './Login/constants';

// ================== COMMON
export function isLoggedIn(state) {
  return state.Auth.get('currentUser') !== null;
}

export function commonGetEnrolledClassData() {
  return (dispatch, getState) => {
    const currentUserId = currentUserIdSelector(getState());
    const currentEnrolments = getState().Enrolments;
    if (currentUserId !== null) {
      dispatch({
        type: START_FETCH_ENROLLED_CLASS_DATA,
      });
      return Resource.read('user', currentUserId, 'getEnrolledClassData').then(
        (data) => {
          const {
            enrolments,
            users2,
            classes,
            courses,
            qualificationEnrolments,
            institutions,
          } = data;
          dispatch({
            type: UPDATE_ENROLLED_CLASS_DATA,
            enrolments: Object.values(enrolments),
            users: Object.values(users2),
            cohortList: Object.values(classes),
            courses: Object.values(courses),
            qualificationEnrolments: Object.values(qualificationEnrolments),
            institutions: Object.values(institutions),
            currentUserId,
          });
          dispatch({
            type: SET_ENROLMENTS_HISTORY,
            enrolments: currentEnrolments,
          });

          const user = users2[currentUserId];
          if (user) {
            // This is to fix a bug with a past implementation of identify()
            // where isOLStaff was being populated with isSuperUser instead of isStaff
            // if we don't set it here, analytics.js (Segment.io client library)
            // will keep picking up and sending the stale value from local storage
            // TODO: move this to a more sensible location
            // (OR remove this code when it is no longer required ... in a month?)
            if (_WEB) {
              metrics.identify(currentUserId, { isOLStaff: user.isStaff });
            }
          }

          return Promise.resolve(data);
        }
      );
    } else {
      return Promise.resolve();
    }
  };
}

export function hideLoginError() {
  return (dispatch) => {
    dispatch({ type: SET_IN_PROGRESS_FALSE });
  };
}

export function stopLoadingLogin() {
  return (dispatch) => {
    dispatch({ type: SET_IN_PROGRESS_FALSE });
  };
}

// ================== WEB
/**
 * TODO pass the cookies in via the RFR "extra" argument (much
 * like the addReducer function) and call it from routesMap
 * so that it can also work on the server side
 */
const cookie = new Cookies();

const TAPFILIATE_COOKIE_KEY = 'tapfiliate';

function matchesCurrentAffiliate(newCookie) {
  const currentCookie = cookie.get(TAPFILIATE_COOKIE_KEY);
  return (
    currentCookie &&
    currentCookie.aid === newCookie.aid &&
    currentCookie.sid === newCookie.sid
  );
}

function addMinutes(date, minutes) {
  return new Date(date.getTime() + minutes * 60000);
}

function saveTapCookie(tapCookie) {
  const expires = addMinutes(new Date(), 30);
  cookie.set(TAPFILIATE_COOKIE_KEY, tapCookie, { path: '/', expires });
}

function extendCurrentAffiliateCookieExpiry() {
  const tapCookie = cookie.get(TAPFILIATE_COOKIE_KEY);
  saveTapCookie(tapCookie);
}

function sendReferralConversion(userId) {
  const tapCookie = cookie.get(TAPFILIATE_COOKIE_KEY);
  if (tapCookie.referralSent) {
    // don't send the referral conversion again
  } else {
    const externalID = `${userId}-${tapCookie.cid}`;
    const metaData = {
      user: userId,
      click: tapCookie.cid,
    };
    window.tap(
      'conversion',
      externalID,
      0,
      { meta_data: metaData },
      'referral'
    );
    tapCookie.referralSent = new Date();
    saveTapCookie(tapCookie);
  }
}

function identifyReferral(currentUser) {
  if (window.tap) {
    const tapCookie = cookie.get(TAPFILIATE_COOKIE_KEY);
    if (tapCookie && currentUser) {
      sendReferralConversion(currentUser);
    }

    window.tap('detectClick', (click) => {
      const { tap_a, tap_s } = parseQueryString();
      const newCookie = {
        aid: tap_a,
        sid: tap_s,
        cid: click.id,
        referralSent: null,
      };

      if (matchesCurrentAffiliate(newCookie)) {
        extendCurrentAffiliateCookieExpiry();
      } else {
        saveTapCookie(newCookie);
      }
      if (currentUser) {
        sendReferralConversion(currentUser);
      }
    });
  }
}

export function setCurrentUser(currentUser) {
  return (dispatch) => {
    identifyReferral(currentUser);
    metrics.identify(currentUser);
    dispatch({ type: SET_CURRENT_USER, currentUser });
  };
}

export function setCurrentUserAccess(access) {
  return (dispatch) => {
    dispatch({ type: SET_CURRENT_USER_ACCESS, access });
  };
}

function retryRequests(dispatch, retriesQueue) {
  for (const request of retriesQueue) {
    request();
  }
  dispatch({ type: CLEAR_RETRIES_QUEUE });
}

export function cancelLogin() {
  return (dispatch) => {
    dispatch({
      type: CANCEL_LOGIN,
    });
  };
}

export function selectForgotPassword() {
  return (dispatch) => {
    dispatch({
      type: FORGOT_PASSWORD,
    });
  };
}

export function setCurrentPortal(currentPortalName) {
  return (dispatch) => {
    dispatch({
      type: AUTH_SET_CURRENT_PORTAL_NAME,
      currentPortalName,
    });
  };
}

export function setCurrentCourse(coursePath) {
  return (dispatch) => {
    dispatch({
      type: AUTH_SET_CURRENT_COURSE,
      coursePath,
    });
  };
}

export function setCurrentCohort(cohortPath) {
  return (dispatch) => {
    dispatch({
      type: AUTH_SET_CURRENT_COHORT,
      cohortPath,
    });
  };
}

export function fetchUserActiveCohortFromPage(pagePath, profileName) {
  return (dispatch) => {
    return Resource.read(PAGE_RESOURCE, pagePath, 'getUserActiveCohort', {
      profileName,
    }).then((activeCohort) => {
      dispatch(setCurrentCohort(activeCohort));
    });
  };
}

export function setLoginMode(mode) {
  return (dispatch) => {
    dispatch({
      type: SET_LOGIN_MODE,
      mode,
    });
  };
}

export function login(email, password, resolve, reject) {
  return (dispatch, getState) => {
    const retriesQueue = getState().Auth.get('retriesQueue');
    const formData = {};
    dispatch({ type: LOGIN_START });
    formData.user = email;
    formData.password = password;
    // formData.logoutUser = true;
    const siteHost = _OL_ORIGIN.replace(/^http(s)?:\/\//, '');
    const currentHost = location.host;
    const onLoginComplete = (response) => {
      metrics.identify(response.user_id);

      // Hack to keep the User flux store up to date so that notifications still works
      // (Remove when notifications frontend is refactored into react/redux)
      // (Move to auth store initialiser when this is done via API instead of DOM)
      UserServerActionCreators.setCurrentUser(response.user.profileName);
      UserServerActionCreators.updateUser(response.user);

      identifyReferral(response.user.userId);
      dispatch({ type: LOGIN_SUCCESS, user: response.user });
      resolve();
      if (retriesQueue.size > 0) {
        retryRequests(dispatch, retriesQueue);
      }
    };
    const onLoginFailure = (response) => {
      dispatch({ type: LOGIN_FAILURE, response });
      ResourceApi.lookup('user', 'getUserForUserName', {
        userName: email,
      }).then(
        (profileName) => {
          if (profileName) {
            reject({
              _error: 'Email or profile name and password do not match',
            });
          } else {
            reject({ email: 'Unknown email address or profile name' });
          }
        },
        () =>
          reject({ _error: 'Email or profile name and password do not match' })
      );
    };
    if (siteHost === currentHost) {
      // same domain
      formData.tokenType = 'legacy';
      const xhr = $.post(`${_OL_ORIGIN}/json/auth/`, formData, null, 'JSON');
      xhr.done(onLoginComplete);
      xhr.fail(onLoginFailure);
    } else {
      // cross-domain
      // log in to OpenLearning.com domain and get a temporary
      // token to share this session with the current domain
      formData.tokenType = 'legacy-temporary';
      const olXhr = $.post('/json/auth/', formData, null, 'JSON');
      olXhr.done((response) => {
        const crossDomainLoginData = {
          source: 'temporary',
          tokenType: 'legacy',
          auth_token: response.auth_token,
        };
        // log in on this domain by sharing the session using the temporary token
        // from Openlearning.com
        const crossDomainXhr = $.ajax({
          type: 'POST',
          url: `${_OL_ORIGIN}/json/auth/`,
          crossDomain: true,
          data: crossDomainLoginData,
          dataType: 'json',
          xhrFields: {
            withCredentials: true,
          },
        });
        crossDomainXhr.done(onLoginComplete);
        crossDomainXhr.fail(onLoginFailure);
      });
      olXhr.fail(onLoginFailure);
    }
  };
}

export function cancelForgotPassword() {
  return (dispatch) => {
    dispatch({
      type: CANCEL_FORGOT_PASSWORD,
    });
  };
}

export function loginRequired(request, mode = LoginMode.signup) {
  return (dispatch, getState) => {
    if (isLoggedIn(getState())) {
      request();
    } else {
      dispatch({ type: LOGIN_REQUIRED, request, mode });
      metrics.logEvent('LoginModal-Opened', {});
    }
  };
}

export function logout(onLogout) {
  return (dispatch, getState) => {
    const state = getState();
    if (isLoggedIn(state)) {
      const formData = {};
      formData.user = state.Auth.get('currentUser');
      formData.logoutEverywhere = true;
      const xhr = $.post('/json/auth/', formData, null, 'JSON');
      xhr.done(() => {
        // log out current domain (we shouldn't need this, but do it for now)
        $.post(`${_OL_ORIGIN}/json/auth/`, formData, null, 'JSON');
        onLogout();
      });
      // pass silently on logout error
    } else {
      onLogout();
    }
  };
}

export function resetPassword(email, resolve, reject) {
  return (dispatch) => {
    dispatch({ type: RESET_PASSWORD_START });
    Resource.lookup('user', 'getUserForUserName', { userName: email }).then(
      (result) => {
        if (result === null) {
          dispatch({ type: RESET_PASSWORD_FAILURE });
          reject({ _error: 'Unknown email address or profile name' });
        } else {
          Resource.execute('user', 'notifyPasswordReset', {
            email,
            userId: null,
          }).then((response) => {
            dispatch({ type: RESET_PASSWORD_SUCCESS, response });
            resolve(response);
          });
        }
      }
    );
  };
}

export function signUp(
  email,
  password,
  fullName,
  subscribe,
  managedByInstitution,
  resolve,
  reject,
  sso = false,
  profileSummary = '',
  avatar = null
) {
  return (dispatch) => {
    dispatch({ type: SIGNUP_START });
    const formData = {};
    formData.fullName = fullName;
    formData.email = email;
    formData.password = password;
    formData.emailAddressConfirm = email;
    // TODO
    formData.isNewsSubscribed = subscribe;
    formData.sso = sso;
    formData.profileSummary = profileSummary;
    formData.signUpFrom = 'web';
    formData.acceptTerms = 'true';
    if (managedByInstitution) {
      formData.managedByInstitution = managedByInstitution;
    }

    Resource.create('user', formData, {}, [], avatar)
      .then(() => {
        metrics.logEvent('GAAccount-Created');
        resolve();
      })
      .fail((error, response) => {
        let errors = {};

        switch (response.error) {
          case 'Invalid':
            if (response.reason) {
              errors = response.reason;

              // In the case forms expect email errors to be in the 'email' field
              if (errors.emailAddress) {
                errors.email = errors.emailAddress;
              }
            }
            break;
          default:
            errors = { _error: 'Signup failed, please check your credentials' };
            break;
        }
        reject(errors);
        dispatch({ type: SIGNUP_FAILURE });
      });
  };
}

export function getEnrolledClassData() {
  return (dispatch, getState) => {
    if (!selectHasRequestedEnrolledClassData(getState())) {
      dispatch(commonGetEnrolledClassData());
    }
  };
}

function getSSODetailsCookie() {
  const ssoDetails = cookie
    .get('sso_details')
    .replace(/"/g, '')
    .replace(/\\054/g, ',')
    .split(',');

  return {
    fullName: ssoDetails[0],
    emailAddress: ssoDetails[1],
  };
}

function getSSOContextCookie() {
  const ssoContext = cookie.get('sso_context');
  const ssoUserDefaultImg = cookie.get('sso_user_image');

  return {
    ssoContext: ssoContext && 'other site',
    ssoUserDefaultImg,
  };
}

export function getSSOContext() {
  const { ssoContext, ssoUserDefaultImg } = getSSOContextCookie();
  return (dispatch) => {
    dispatch({
      type: SSO_USER_CONTEXT,
      ssoContext,
      ssoUserDefaultImg,
    });
  };
}

export function getSSOUserDetails() {
  return (dispatch) => {
    dispatch({
      type: CURRENT_SSO_USER_DETAILS,
      currentUserSSODetails: getSSODetailsCookie(),
    });
  };
}

export function signUpRequired() {
  return (dispatch) => {
    const { emailAddress } = getSSODetailsCookie();

    Resource.lookup(USER_RESOURCE, 'resources', {
      initArgsList: [emailAddress],
      argName: 'emailAddress',
      ignoreMissing: true,
    }).then((result) => {
      dispatch({
        type: SIGNUP_USER_REQUIRED,
        signUpUserRequired: emailAddress && Immutable.fromJS(result).size === 0,
      });
    });
  };
}

export function signUserData(payload) {
  return () => {
    return Resource.lookup('auth', 'signUserData', { payload });
  };
}

// ================== NATIVE
export function navigateToInitialTab() {
  return (dispatch, getState) => {
    const cohortsByCourseCreator = selectFiltersForFeed(getState());
    if (
      !cohortsByCourseCreator.has('cohortsList') ||
      cohortsByCourseCreator.get('cohortsList').size === 0
    ) {
      dispatch({ type: MY_COURSES_SCREEN });
    } else {
      dispatch({
        type: ACTIVITY_FEED_SCREEN,
        meta: {
          direction: 'replace',
        },
      });
    }
  };
}

export function getCustomDomainCookie(siteUrl) {
  return async (dispatch) => {
    const authToken = await getToken();
    const formData = new FormData();
    formData.append('tokenType', 'legacy');
    formData.append('source', 'token');
    formData.append('auth_token', authToken);
    const parsedUrl = urlParser.parse(siteUrl);

    return Resource.justFetch(`${siteUrl}/json/auth/`, {
      body: formData,
      method: 'POST',
      credentials: 'omit',
    }).then((response) => {
      if (response.ok) {
        return response.json().then((/* result */) => {
          try {
            const legacyToken = response.headers.get('set-cookie');
            dispatch({
              type: SET_SUBDOMAIN_COOKIE,
              url: parsedUrl.host,
              legacyToken,
            });
            if (legacyToken) {
              return CookieManager.setFromResponse(siteUrl, legacyToken).then(
                (/* cookieRes */) => {
                  // if cookieRes === true
                  // mean successfully updated the cookie
                  return response;
                }
              );
            }
            throw response;
          } catch (err) {
            throw err;
          }
        });
      }
      throw response;
    }, Resource.handler.handleUnexpectedError);
  };
}

export function emptyLoginSession() {
  return (dispatch) => {
    Resource.resetHeaders();
    dispatch({ type: SET_LEGACY_TOKEN, legacyToken: null });
    try {
      LoginManager.logOut();
    } catch (err) {
      // try logout fb
    }
    return CookieManager.clearAll()
      .then(removeToken)
      .then(() => {
        dispatch({ type: LOGOUT_SUCCESS });
        return true;
      });
  };
}

export function startTrackingUser() {
  return (dispatch, getState) => {
    const currentUserId = getState().Auth.get('currentUser');
    const currentUserProfileName = getState().Users.getIn(
      [currentUserId, 'profileName'],
      ''
    );
    // sentry
    setUserContext({ userID: currentUserId });
    setExtraContext({ profileName: currentUserProfileName });
    setEnvironment();

    // segmentation
    // query user subscription plan
    dispatch(loadCurrentUserSubscriptionPlanData).then(() => {
      const userEducatorSubscriptionPlan = selectCurrentUserEducatorSubscription(
        getState()
      );
      let options = {};
      if (!userEducatorSubscriptionPlan) {
        options = {
          ...NO_EDUCATOR_SUBSCRIPTION_INTEGRATIONS,
        };
      }

      setUser(
        currentUserId,
        {},
        {
          integrations: options,
        }
      );
    });
  };
}

export function resetTrackingUser() {
  return (dispatch) => {
    // sentry
    clearContext();
    setEnvironment();

    // segmentation
    clearIdentity();
  };
}

export function navigateToAuthStack() {
  return (dispatch) => {
    dispatch(navigate(AUTH_STACK));
    dispatch({
      type: LOGIN_SCREEN,
      meta: { direction: 'replace' },
    });
  };
}

export function logoutApp() {
  return (dispatch) => {
    dispatch({ type: LOGOUT_START });

    const formData = new FormData();
    formData.append('logoutElsewhere', false);
    formData.append('logoutHere', true);

    // de-register push notification first before the actual logout happen
    return dispatch(clearFCMTokenFromServer())
      .then(() => {
        return Resource.customResourceRequest(
          'POST',
          `/json/auth/logout/`,
          formData
        );
      })
      .then(() => {
        dispatch({ type: SET_LOGIN_DATE, lastLoginDate: null });
        dispatch(emptyLoginSession());
        dispatch(resetTrackingUser());
        dispatch(navigateToAuthStack());
      })
      .catch((err) => {
        dispatch({ type: LOGOUT_FAILURE, error: err });
        dispatch(emptyLoginSession());
        dispatch(resetTrackingUser());
        dispatch(navigateToAuthStack());
      });
  };
}

export function getLegacyToken() {
  return async (dispatch) => {
    const authToken = await getToken();
    const formData = new FormData();
    formData.append('tokenType', 'legacy');
    formData.append('source', 'token');
    formData.append('auth_token', authToken);

    return CookieManager.clearAll()
      .then((/* cookieRes */) => {
        // if cookieRes === true
        // mean successfully clear all the cookie
        return Resource.justFetch(`${_OL_ORIGIN}/json/auth/`, {
          body: formData,
          method: 'POST',
          credentials: 'omit',
        });
      })
      .then((response) => {
        if (response.ok) {
          const result = response.json();
          return result.then((/* result */) => {
            const legacyToken = response.headers.get('set-cookie');
            dispatch({ type: SET_LEGACY_TOKEN, legacyToken });
            if (legacyToken) {
              return CookieManager.setFromResponse(
                _OL_ORIGIN,
                legacyToken
              ).then((/* cookieRes */) => {
                // if cookieRes === true
                // mean successfully updated the cookie
                return result;
              });
            }
            throw Error('Failed to renew session [3]');
          });
        }
        throw Error('Failed to renew session [4]');
      }, Resource.handler.handleUnexpectedError)
      .catch((err) => {
        // silent the error
        return dispatch(emptyLoginSession());
      });
  };
}

export function getEnrolledClassDataForApp() {
  return (dispatch) => {
    return dispatch(commonGetEnrolledClassData()).then((result) => result);
  };
}

export function navigateToAppTabs() {
  return (dispatch) => {
    dispatch(navigate(APP_TABS));
    dispatch({
      type: APP_TAB_SET_PARAMS,
    });
    dispatch(navigateToInitialTab());
  };
}

const onAppLoginSuccess = () => {
  return (dispatch, getState) => {
    dispatch(getLegacyToken());
    return dispatch(getEnrolledClassDataForApp()).then((result) => {
      // Temporarily workaround before whitelabel login API is ready
      const whiteLabelInstitution = makeSelectWhiteLabelInstitution(getState());
      if (whiteLabelInstitution) {
        const { institutions } = result;
        const isEnrolled = Object.prototype.hasOwnProperty.call(
          institutions,
          whiteLabelInstitution.get('institutionName')
        );
        if (!isEnrolled) {
          return Promise.reject(
            Error('User not enrolled in current the white label institution')
          );
        }
      }
      dispatch(initializeFilterForFeed());
      dispatch(startTrackingUser());
      dispatch(fetchUnreadBadge());
      // register push notification token only after successfully login
      dispatch(registerPushNotificationToken());
      dispatch(stopLoadingLogin());
      dispatch(navigateToAppTabs());
      return Promise.resolve();
    });
  };
};

const onFbLogin = (graphData, token, createUser) => {
  return (dispatch) => {
    const params = new FormData();
    params.append('facebookUserID', graphData.id);
    params.append('facebookAccessToken', token);
    params.append('graphId', graphData.id);
    params.append('createUser', createUser);
    dispatch({
      type: FACEBOOK_LOGIN_START,
    });
    return Resource.justFetch(`${_OL_ORIGIN}/json/auth/facebook/`, {
      body: params,
      method: 'POST',
    });
  };
};

const onFbLoginSuccess = (authToken) => {
  return (dispatch) => {
    return setToken(authToken).then(() => {
      Resource.loadTokenIntoHeaders(authToken);
      return dispatch(getLegacyToken()).then((response) => {
        dispatch({
          type: FACEBOOK_LOGIN_SUCCESS,
          userId: response.user_id,
        });
        dispatch({ type: SET_LOGIN_DATE, lastLoginDate: new Date() });
        return dispatch(onAppLoginSuccess());
      });
    });
  };
};

export function facebookLogin(token) {
  return (dispatch) => {
    Resource.justFetch(
      `https://graph.facebook.com/me?fields=id&access_token=${token}`,
      { method: 'GET' }
    )
      .then((response) => {
        if (response.ok) {
          return response.json().then((graphData) => {
            return dispatch(onFbLogin(graphData, token, false)).then((res) => {
              if (res.ok) {
                return res.json().then((data) => {
                  const authToken = data.auth_token;
                  return dispatch(onFbLoginSuccess(authToken));
                });
              } else {
                return dispatch(onFbLogin(graphData, token, true)).then(
                  (responseData) => {
                    return responseData.json().then((result) => {
                      const authToken = result.auth_token;
                      return dispatch(onFbLoginSuccess(authToken));
                    });
                  }
                );
              }
            });
          });
        }
        throw Error('Failed to login with facebook');
      }, Resource.handler.handleUnexpectedError)
      .catch((err) => {
        const errorMessage = err || 'Facebook login failed';
        Alert.alert('Login Failed', errorMessage, [{ text: 'OK' }], {
          cancelable: false,
        });
        dispatch({
          type: FACEBOOK_LOGIN_FAILURE,
          error: errorMessage,
        });
        dispatch(emptyLoginSession());
      });
  };
}

export function loginApp(nameOrEmail, password) {
  return (dispatch) => {
    const formData = new FormData();
    formData.append('user', nameOrEmail);
    formData.append('password', password);
    formData.append('tokenType', 'token');

    dispatch({ type: LOGIN_START });

    return CookieManager.clearAll()
      .then((/* cookieRes */) => {
        // if cookieRes === true
        // mean successfully clear all the cookie
        return Resource.justFetch(`${_OL_ORIGIN}/json/auth/`, {
          method: 'POST',
          body: formData,
          credentials: 'omit',
        });
      })
      .then((response) => {
        if (response.ok) {
          return response.json().then((result) => {
            const authToken = result.auth_token;
            return setToken(authToken).then(async () => {
              Resource.loadTokenIntoHeaders(authToken);
              dispatch({ type: LOGIN_SUCCESS, user: result.user });
              dispatch({ type: SET_LOGIN_DATE, lastLoginDate: new Date() });
              return dispatch(onAppLoginSuccess());
            });
          });
        }
        if (response.status >= 500) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject({ status: response.status });
        }
        return Resource.handler.handleNegativeResponse(null, response);
      }, Resource.handler.handleUnexpectedError)
      .catch((err) => {
        dispatch(emptyLoginSession());
        if (err.status >= 500) {
          dispatch({ type: SET_IN_PROGRESS_FALSE });
          showNotification({
            title: 'Server is now under maintenance',
            message: 'We are working to serve you even better!',
          });
        } else if (err === 'Error: Network error') {
          dispatch({ type: SET_IN_PROGRESS_FALSE });
          showNotification({
            title: 'Network error',
            message: 'No internet connection found.',
          });
        } else {
          const errorMessage = err || 'Invalid email address or password.';
          dispatch({ type: LOGIN_FAILURE, error: errorMessage });
        }
      });
  };
}

export function refreshToken() {
  return async (dispatch) => {
    try {
      const authToken = await getToken();
      // if refresh token is not set for some reason.
      // may due to inaccessible data from keychain helper
      if (!authToken) {
        return dispatch(emptyLoginSession());
      }
      // set & get newly refreshed auth token in resource header
      const authReqHeader = await Resource.loadTokenIntoHeaders(authToken);
      const response = await Resource.justFetch(
        `${_OL_ORIGIN}/json/auth/renew/`,
        {
          method: 'POST',
          credentials: 'omit',
          headers: authReqHeader,
        }
      );
      if (response.ok) {
        const result = await response.json();
        if (result.success) {
          await setToken(result.auth_token);
          Resource.loadTokenIntoHeaders(result.auth_token);
          // try to renew and save the legacy token as well
          dispatch(getLegacyToken());
        }
      }
      if (response.status === 403) {
        Alert.alert(
          'Session expired',
          'Press OK to login again',
          [
            {
              text: 'OK',
              onPress: () => {
                dispatch({ type: LOGOUT_SUCCESS });
                dispatch(emptyLoginSession());
                dispatch(navigateToAuthStack());
              },
            },
          ],
          {
            cancelable: false,
          }
        );
      }
    } catch (err) {
      // silent error
    }
  };
}

export function resetPasswordApp(nameOrEmail) {
  return (dispatch) => {
    dispatch({ type: RESET_PASSWORD_START });
    Resource.lookup(USER_RESOURCE, 'getUserForUserName', {
      userName: nameOrEmail,
    })
      .then((result) => {
        if (!result) {
          Alert.alert(
            'Reset Password Failed',
            'Unknown email address or profile name',
            [{ text: 'OK' }],
            {
              cancelable: false,
            }
          );
          dispatch({
            type: RESET_PASSWORD_FAILURE,
            errorMessage: 'Unknown email address or profile name',
          });
        } else {
          const formData = new FormData();
          formData.append('email', nameOrEmail);
          formData.append('userId', null);
          Resource.execute(USER_RESOURCE, 'notifyPasswordReset', formData).then(
            () => {
              dispatch({ type: RESET_PASSWORD_SUCCESS });
              Alert.alert(
                'Reset Password Success',
                `An email has been sent to ${nameOrEmail} with instructions to reset your password.`,
                [
                  {
                    text: 'OK',
                    onPress: () => {
                      dispatch(stackAction(StackActions.POP));
                    },
                  },
                ],
                {
                  cancelable: false,
                }
              );
            }
          );
        }
      })
      .catch((error) => {
        Alert.alert('Reset Password Failed', error, [{ text: 'OK' }], {
          cancelable: false,
        });
        dispatch({
          type: RESET_PASSWORD_FAILURE,
          errorMessage: error,
        });
      });
  };
}

export function fetchCurrentUserFrontChatData(currentCoursePath) {
  return (dispatch, getState) => {
    const state = getState();

    const currentUser = currentUserIdSelector(state);
    if (!currentUser) {
      return Promise.resolve({ success: false });
    }

    return ResourceApi.read(
      USER_RESOURCE,
      currentUser,
      'getFrontChatDataForCourseAdmin',
      {
        coursePath: currentCoursePath,
      }
    );
  };
}

export function signUpApp(email, password, name, OS) {
  return (dispatch) => {
    dispatch({ type: SIGNUP_START });
    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);
    formData.append('fullName', name);
    formData.append('signUpFrom', OS);
    formData.append('acceptsTerms', 'true');
    Resource.create(USER_RESOURCE, formData)
      .then(() => {
        dispatch(loginApp(email, password));
        dispatch({ type: SIGNUP_SUCCESS });
      })
      .catch((error) => {
        Alert.alert('Signup Failed', error, [{ text: 'OK' }], {
          cancelable: false,
        });
        dispatch({ type: SIGNUP_FAILURE, errorMessage: error });
      });
  };
}
